
import React from 'react';
import { Button } from '@/components/ui/button';
import { Image, X } from 'lucide-react';
import { FormLabel } from '@/components/ui/form';

interface ProductImageUploadProps {
  images: string[];
  onImageUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  removeImage: (index: number) => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
}

const ProductImageUpload: React.FC<ProductImageUploadProps> = ({
  images,
  onImageUpload,
  removeImage,
  fileInputRef,
}) => {
  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="space-y-2">
      <FormLabel>Product Images (Max 5)</FormLabel>
      <div className="grid grid-cols-5 gap-2">
        {images.map((image, index) => (
          <div key={index} className="relative aspect-square">
            <img 
              src={image} 
              alt={`Product ${index}`} 
              className="w-full h-full object-cover rounded-md border border-gray-200"
            />
            <Button
              type="button"
              size="icon"
              variant="destructive"
              className="absolute -top-2 -right-2 h-6 w-6 rounded-full"
              onClick={() => removeImage(index)}
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        ))}
        
        {images.length < 5 && (
          <Button
            type="button"
            variant="outline"
            className="aspect-square flex flex-col items-center justify-center border-dashed"
            onClick={triggerFileInput}
          >
            <Image className="h-6 w-6 mb-1" />
            <span className="text-xs">Add</span>
          </Button>
        )}
      </div>
      <input
        type="file"
        ref={fileInputRef}
        onChange={onImageUpload}
        accept="image/*"
        multiple
        className="hidden"
      />
    </div>
  );
};

export default ProductImageUpload;
